import React, { useMemo, useState } from 'react';

import { useQuery } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

import { usePosts } from '@hooks';

import PostsList, {
  ListPostFields,
  listPostsFields,
} from '@components/PostsList';

import RoutesPath from '@router/routes';
import { enums } from '@utils';

import Filters from '../Filters';
import { PostSelectFilter } from '../Filters/styles';

const ListFinishedPosts: React.FC = () => {
  const { search } = useLocation();

  const statusQuery = useMemo(
    () => new URLSearchParams(search).get('status'),
    [search]
  );

  const [queryParams, setQueryParams] = useState<PostsQuery>({
    fields: listPostsFields as unknown as Array<keyof Post>,
    page: 1,
    pageSize: 6,
    isComplete: true,
    status: statusQuery ? enums.PostStatusReverseMap[statusQuery] : undefined,
  });

  const { listPosts } = usePosts();
  const navigate = useNavigate();

  const fetchPosts = useQuery(['posts', queryParams], () =>
    listPosts<ListPostFields>(queryParams)
  );

  return (
    <>
      <Filters values={queryParams} onChange={setQueryParams}>
        <PostSelectFilter
          data-cy="status-filter"
          onChange={(event) => {
            setQueryParams((prevState) => ({
              ...prevState,
              status: event.target.value as enums.PostStatus,
            }));
          }}
          value={queryParams.status}
        >
          <option value="">Status: Todos</option>
          {Object.values(enums.PostStatus).map((status) => (
            <option key={status} value={status}>
              {enums.PostStatusMap[status]}
            </option>
          ))}
        </PostSelectFilter>
      </Filters>
      <PostsList
        canSelectPosts
        showStatusIndicator
        fetchPosts={fetchPosts}
        page={queryParams.page}
        onChangePage={(page) => setQueryParams({ ...queryParams, page })}
        onClick={(post) => {
          navigate(
            RoutesPath.private.posts.detail.replace(':postId', post.toString())
          );
        }}
      />
    </>
  );
};

export default ListFinishedPosts;
